import React, { useEffect, useState, useRef } from 'react';
import { FadeIn } from './FadeIn';
import { useInView } from 'framer-motion';
function Counter({
  target,
  suffix = '',
  duration = 2000
}: {
  target: number;
  suffix?: string;
  duration?: number;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (!isInView) return;
    let start = 0;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration, isInView]);
  return <span ref={ref} data-id="element-36">
      {count}
      {suffix}
    </span>;
}
export function AnimatedStats() {
  return <section className="py-12 md:py-20 bg-cream text-forest" data-id="element-37">
      <FadeIn className="container mx-auto px-5 max-w-[1100px]" data-id="element-38">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 text-center" data-id="element-39">
          <div data-id="element-40">
            <div className="font-serif text-6xl text-burgundy mb-2" data-id="element-41">
              <Counter target={75} suffix="%" data-id="element-42" />
            </div>
            <p className="font-medium text-sm uppercase tracking-wider opacity-80" data-id="element-43">
              Reportan reducción de dolor al eliminar gluten
            </p>
          </div>

          <div data-id="element-44">
            <div className="font-serif text-6xl text-burgundy mb-2" data-id="element-45">
              <Counter target={60} suffix="%" data-id="element-46" />
            </div>
            <p className="font-medium text-sm uppercase tracking-wider opacity-80" data-id="element-47">
              Reducción promedio de dolor en el primer ciclo
            </p>
          </div>

          <div data-id="element-48">
            <div className="font-serif text-6xl text-burgundy mb-2" data-id="element-49">
              <Counter target={21} data-id="element-50" />
            </div>
            <p className="font-medium text-sm uppercase tracking-wider opacity-80" data-id="element-51">
              Días para transformar tu vientre
            </p>
          </div>

          <div data-id="element-52">
            <div className="font-serif text-6xl text-burgundy mb-2" data-id="element-53">80/20</div>
            <p className="font-medium text-sm uppercase tracking-wider opacity-80" data-id="element-54">
              La regla que mantiene los resultados
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}